export default {
    environment: 'DEVELOPMENT'
}

const url__homepage = '/';
const url__images = '/images/';
const img__image_placeholder = '/img/image-placeholder.jpg';
const img__no_image = '/img/no-image.png';
const img__logo = '/img/logo.svg';
const img__watch_crystal = '/img/watch/crystal.svg';
const img__watch_features = '/img/watch/features.svg';
const img__watch_material = '/img/watch/material.svg';
const img__watch_movement = '/img/watch/movement.svg';
const img__watch_projection_main = '/img/watch/projection-main.svg';
const img__watch_projection_side = '/img/watch/projection-side.svg';
const img__watch_water_resistance = '/img/watch/water-resistance.svg';

export {
    url__homepage,
    url__images,
    img__image_placeholder,
    img__no_image,
    img__logo,
    img__watch_crystal,
    img__watch_features,
    img__watch_material,
    img__watch_movement,
    img__watch_projection_main,
    img__watch_projection_side,
    img__watch_water_resistance,
}
